var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloseModal = function SvgIconCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#AAA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 9.5-5 5m0-5 5 5",
    strokeLinecap: "round"
  }))));
};
export default SvgIconCloseModal;